import React from 'react';

export default function PageHero({ bgImage, kicker, heading, paragraph }) {
    // Mtindo wa kuweka background image dynamically kulingana na prop iliyopitishwa
    const heroStyle = {
        backgroundImage: bgImage ? `url(${bgImage})` : 'none'
    };


    return (
        <section className="ycsc-custom-page-hero" style={heroStyle}>
            {/* Overlay ya giza la kisasa kuhakikisha maandishi yanasomeka vizuri */}
            <div className="hero-overlay-dark animate__animated animate__fadeIn">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-10 col-lg-8 text-center text-md-start">
                            
                            {/* Kicker (Maandishi madogo ya juu, mfano: "KUHUSU SISI") */}
                            {kicker && (
                                <span className="hero-kicker-text text-uppercase tracking-wider fw-bold mb-2 d-inline-block">
                                    {kicker}
                                </span>
                            )}
                            
                            {/* Heading (Kichwa kikuu cha ukurasa) */}
                            {heading && (
                                <h1 className="display-4 fw-extrabold hero-main-heading mb-3 text-white">
                                    {heading}
                                </h1>
                            )}
                            
                            {/* Short Paragraph (Maelezo mafupi) */}
                            {paragraph && (
                                <p className="lead hero-short-paragraph text-white-50 m-0">
                                    {paragraph}
                                </p>
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}